import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent {
  @Input() total!: number;
  @Input('filters') set _filters(value: FormGroup) {
    this.filters = value;
    this.currentViewedPage = value.get('skip')?.value / value.get('take')?.value;
  }
  @Input() showNumeric = true;
  @Input() scrollToId!: string;

  public filters!: FormGroup;
  public currentViewedPage!: number;

  get numberOfPages(): number {
    return Math.ceil(this.total / this.filters.get('take')?.value || 1);
  }

  get pages(): number[] {
    return Array.from({ length: this.numberOfPages }, (_, i) => i + 1);
  }

  get currentPage(): number {
    return this.filters.get('skip')?.value / this.filters.get('take')?.value + 1;
  }

  get startOfSlicePages(): number {
    const start = this.currentViewedPage - (this.currentViewedPage != 1 ? (this.currentViewedPage != this.numberOfPages ? 2 : 3) : 1);
    return start > 0 ? start : 0;
  }

  get endOfSlicePages(): number {
    return this.currentViewedPage + (this.currentViewedPage != 1 ? 1 : 2);
  }

  constructor(@Inject(PLATFORM_ID) private platformId: string, private route: ActivatedRoute) {}

  // ngOnInit(): void {
  //   this.route.queryParams.subscribe((item) => item['page'] && this.setPage(Number(item['page'])));
  // }

  public setCurrentPage(value: number): void {
    if (value != this.currentPage) {
      this.setPage(value);
    }
  }

  public loadMoreData(value: number) {
    return this.setPage(value + 1);
  }

  public get prevPage() {
    return this.currentPage == 2 ? undefined : this.currentPage - 1;
  }

  public get nextPage() {
    return this.currentPage + 1;
  }

  public prevViewedPage(): void {
    this.currentViewedPage = this.currentViewedPage - 3 < 1 ? 1 : this.currentViewedPage - 3;
  }

  public nextViewedPage(): void {
    this.currentViewedPage = this.currentViewedPage + 3 > this.numberOfPages ? this.numberOfPages : this.currentViewedPage + 3;
  }

  private setPage(value: number): void {
    this.filters.patchValue({ skip: (value - 1) * this.filters.get('take')?.value });
    this.currentViewedPage = this.currentPage;
    if (isPlatformBrowser(this.platformId)) {
      if (this.scrollToId) {
        const el = document.getElementById(this.scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        document.documentElement ? document.documentElement.scrollTo({ top: 0, behavior: 'smooth' }) : document.body.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  }
}
